'use client'
import { Chat } from '../../WebinarDetailModule/components/Chat'
import styles from "./WebinarContent.module.scss"

const WebinarContent = ({ data }: { data: any }) => {
    return (
        <div
            className={styles.wrapper}
        >
            <iframe
                style={{ width: '100%', height: '100%' }}
                frameBorder={'0'}
                src={data.webinar_link}
                allow='autoplay; encrypted-media; clipboard-write'
                allowFullScreen
            ></iframe>
            {data?.chat && data?.chat?.id ? <Chat data={data.chat} /> : null}
        </div>
    )
}

export default WebinarContent
